const LS_STATE_KEY = "state";

type PersistedState = {
  sessionToken?: string;
  [key: string]: any;
};

// TODO: use session storage instead of local storage
export const loadState = (): Partial<PersistedState> | undefined => {
  try {
    const serializedState = localStorage.getItem(LS_STATE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error("Error loading state from localStorage:", err);
    return undefined;
  }
};

export const saveState = (state: PersistedState): void => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(LS_STATE_KEY, serializedState);
  } catch (err) {
    console.error("Error saving state to localStorage:", err);
  }
};

export const clearState = (): void => localStorage.removeItem(LS_STATE_KEY);
